import React from 'react';
import { Link } from 'react-router-dom';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import Products from '../../Models/Products';
import { Header, Footer } from '../Common';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class BuyerRequestHome extends React.Component {
    constructor(props) {
        super(props);
        if (localStorage.getItem('info') === null || localStorage.getItem('info') === '') {
            window.location.href = '/login';
            // this.props.history.push('/login');
        };
        this.state = {
            minHeight: "475px",
            RequestList: [],
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        var id = logged_user.id;
        this.getRequestList(id);
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getRequestList(id) {
        Products.getSellerRequest(id).then(res => {
            this.setState({ RequestList: res.data.payload })
        })
    }

    // Request Button Responsive
    requestButton() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="">
                    <div style={{ padding: "10%" }}>
                        <div style={{ textAlign: "right" }}>
                            <Link style={{ textDecoration: "none" }} to={'/post-request-buyer'} href="">
                                <div className="row" >
                                    <div className="col-md-4"></div>
                                    <div className="use_request_button category-right seller_button col-md-4 shadow-text" style={{ cursor: "pointer", textAlign: "center", width: "-webkit-fill-available", marginTop: '0px' }} >
                                        リクエストを投稿する
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="">
                    <div style={{ padding: "6%", border: "1px solid #ddd" }}>
                        <div style={{ textAlign: "right" }}>
                            <Link style={{ textDecoration: "none" }} to={'/post-request-buyer'} href="">
                                <div className="row" >
                                    <div className="col-md-4"></div>
                                    <div className="use_request_button category-right seller_button col-md-4 shadow-text" style={{ cursor: "pointer", textAlign: "center", padding: "2%", width: "-webkit-fill-available" }} >
                                        リクエストを投稿する
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <BuyerSidebar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%", fontSize: '20px' }}>
                                    リクエスト
                                </div>
                                <div style={{ minHeight: "500px", border: "1px solid #ddd", padding: "0%" }}>
                                    {this.requestButton()}
                                    {this.state.RequestList.map(req =>
                                        <div className="" key={req.id} style={{ borderBottom: "1px solid #f4f2f0", paddingTop: "3%", paddingBottom: "2%" }}>
                                            <div className="font_12 pb-3" style={{ paddingLeft: "15px" }}>
                                                <Link to={{
                                                    pathname: `/buyer-request-details`,
                                                    state: {
                                                        id: req.id
                                                    }
                                                }} >
                                                    <b class="gray">{req.title}</b>
                                                </Link>
                                            </div>
                                            <div className="font_12 row col" style={{}}>
                                                <div className="col-6 text-left"><b>{req.budget_amount}</b></div>
                                                <div className="col-6 text-right remove_pads">{(JSON.stringify(req.application_date)).substring(1, 11)}</div>
                                            </div>
                                            <div className="font_12 col">
                                                提案数 : <b>{req.number_of_proposals}</b>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            リクエスト
                                    </div>
                                        <div style={{ minHeight: "500px", border: "1px solid #ddd", padding: "4%" }}>
                                            {this.requestButton()}
                                            {(() => {
                                                if (this.state.RequestList.length < 1) {
                                                    return (
                                                        <div></div>
                                                    )
                                                } else {
                                                    return (
                                                        <div className="col-md-12 row" style={{ borderBottom: "1px solid #ddd", paddingTop: "3%", paddingBottom: "2%" }}>
                                                            <div className="col-md-5 font_12">
                                                                相談内容
                                                        </div>
                                                            <div className="col-md-2 font_12">
                                                                提案期限
                                                        </div>
                                                            <div className="col-md-3 font_12">
                                                                予算
                                                        </div>
                                                            <div className="col-md-2 font_12">
                                                                提案数
                                                        </div>
                                                        </div>
                                                    )
                                                }
                                            })()}

                                            {this.state.RequestList.map(req =>
                                                <div className="col-md-12 row" key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                                    <div className="col-md-5 font_12">
                                                        <Link to={{
                                                            pathname: `/buyer-request-details`,
                                                            state: {
                                                                id: req.id
                                                            }
                                                        }} >
                                                            <b>{req.title}</b>
                                                        </Link>
                                                    </div>
                                                    <div className="col-md-2 font_12">
                                                        {(JSON.stringify(req.application_date)).substring(1, 11)}
                                                    </div>
                                                    <div className="col-md-3 font_12">
                                                        <b>{req.budget_amount}</b>
                                                    </div>
                                                    <div className="col-md-2 font_12">
                                                        <b>{req.number_of_proposals}</b>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}


export { BuyerRequestHome };